import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import PaymentSkeleton from './paymentSkeleton';
import Loader from '../../../assets/components/loader';

import MarquetCards from '../../../utils/components/MarquetCards';

import {
  resetSignUp,
  updateBillingInfo,
  createCustomerCard,
  createCustomerSubscription,
  updateDeal,
  createDeal,
  updateContact,
  getCustomerId,
  updateCustomerCard,

  getCountries,
  getStates,
  getCities
} from '../../../store/actions';

import {
  getCustomer,
  camelToSnake,
  validateBilling,
  validateCard,
  renderCardYear,
  renderCardMonth,
  inputStatus
} from '../../../utils/helpers';

import { CountryCodes } from '../../../shared/CountryCodes';
import { Country, State, City } from 'country-state-city';

const dialCodes = CountryCodes;
const countries = Country.getAllCountries();
const states = State;
const cities = City;

const Payment = () => {

  const customerId = getCustomer();
  const dispatch = useDispatch();
  const paymentInfo = useSelector((state) => state.payment);
  const navigate = useNavigate();

  useEffect(() => {
    if (customerId === "") {
      navigate('/')
    }
  }, [])

  const [useCustomerData, setUseCustomerData] = useState(true)
  const [useNewCard, setUseNewCard] = useState(false)
  const [user, setUser] = useState({
    firstName: {
      value: "",
      focused: false,
      required: true,
      error: ""
    },
    lastName: {
      value: "",
      focused: false,
      required: true,
      error: ""
    },
    email: {
      value: "",
      focused: false,
      required: true,
      error: ""
    },
    cfCountry: {
      value: "",
      focused: false,
      required: true,
      error: ""
    },
    cfState: {
      value: "",
      focused: false,
      required: true,
      error: ""
    },
    cfCity: {
      value: "",
      focused: false,
      required: false,
      error: ""
    },
    cfAddress: {
      value: "",
      focused: false,
      required: true,
      error: ""
    },
    cfDialCountryCode: {
      value: "",
      focused: false,
      required: true,
      error: ""
    },
    cfSinglePhoneNumber: {
      value: "",
      focused: false,
      required: true,
      error: ""
    },
    cfZip: {
      value: ""
    }
  })

  const [card, setCard] = useState({
    firstName: {
      value: "",
      focused: false,
      required: true,
      error: ""
    },
    lastName: {
      value: "",
      focused: false,
      required: true,
      error: ""
    },
    maskedNumber: {
      value: "",
      focused: false,
      required: true,
      error: ""
    },
    expiryMonth: {
      value: "",
      focused: false,
      required: true,
      error: ""
    },
    expiryYear: {
      value: "",
      focused: false,
      required: true,
      error: ""
    },
    cvc: {
      value: "",
      focused: false,
      required: true,
      error: ""
    }
  })

  const [terms, setTerms] = useState({
    term1: false,
    term2: false,
    term3: false
  })

  const [totals, setTotals] = useState({
    subTotal: "",
    tax: "",
    total: ""
  })

  const handleTerms = (ev) => {
    setTerms({...terms,
      [ev.target.name]:ev.target.value
    })
  }

  const handleInputChangeUser = (ev) => {
    if (ev.target.name === "cfCountry") {
      setUser(prevUser => ({
        ...prevUser,
        [ev.target.name]: {
          ...prevUser["cfCity"],
          value: "",
          focused: true,
          error: prevUser["cfCity"].required ? validateBilling("cfCity", "") : ""
        }
      }))
    }
    setUser(prevUser => ({
      ...prevUser,
      [ev.target.name]: {
        ...prevUser[ev.target.name],
        value: ev.target.value,
        focused: true,
        error: prevUser[ev.target.name].required ? validateBilling(ev.target.name, ev.target.value) : ""
      }
    }))
  }

  const handleInputChangeCard = (ev) => {
    if (ev.target.name === "expiryYear"){
      setCard(prevCard => ({
        ...prevCard,
        ["expiryMonth"]: {
          ...prevCard["expiryMonth"],
          value: prevCard["expiryMonth"].value,
          focused: true,
          error: prevCard["expiryMonth"].required ? validateCard("expiryMonth", prevCard["expiryMonth"].value, card) : ""
        },
        [ev.target.name]: {
          ...prevCard[ev.target.name],
          value: ev.target.value,
          focused: true,
          error: prevCard[ev.target.name].required ? validateCard(ev.target.name, ev.target.value, card) : ""
        }
      }))
    } else if (ev.target.name === "expiryMonth"){
      setCard(prevCard => ({
        ...prevCard,
        ["expiryYear"]: {
          ...prevCard["expiryYear"],
          value: prevCard["expiryYear"].value,
          focused: true,
          error: prevCard["expiryYear"].required ? validateCard("expiryYear", prevCard["expiryYear"].value, card) : ""
        },
        [ev.target.name]: {
          ...prevCard[ev.target.name],
          value: ev.target.value,
          focused: true,
          error: prevCard[ev.target.name].required ? validateCard(ev.target.name, ev.target.value, card) : ""
        }
      }))
    }else{
      setCard(prevCard => ({
        ...prevCard,
        [ev.target.name]: {
          ...prevCard[ev.target.name],
          value: ev.target.value,
          focused: true,
          error: prevCard[ev.target.name].required ? validateCard(ev.target.name, ev.target.value, card) : ""
        }
      }))
    }
  }

  const handleOnFocusBilling = (ev) => {
    if (ev.target.name === "cfDialCountryCode" || ev.target.name === "cfSinglePhoneNumber") {
      setUser(prevUser => ({
        ...prevUser,
        cfDialCountryCode: {
          ...prevUser.cfDialCountryCode,
          focused: true,
          error: prevUser.cfDialCountryCode.required ? validateBilling("cfDialCountryCode", prevUser.cfDialCountryCode.value) : ""
        },
        cfSinglePhoneNumber: {
          ...prevUser.cfSinglePhoneNumber,
          focused: true,
          error: prevUser.cfSinglePhoneNumber.required ? validateBilling("cfSinglePhoneNumber", prevUser.cfSinglePhoneNumber.value) : ""
        }
      }))
    }
    setUser(prevUser => ({
      ...prevUser,
      [ev.target.name]: {
        ...prevUser[ev.target.name],
        focused: true,
        error: prevUser[ev.target.name].required ? validateBilling(ev.target.name, ev.target.value) : ""
      }
    }))
  }

  const handleOnFocusCard = (ev) => {
    if (ev.target.name === "expiryMonth" || ev.target.name === "expiryMonth") {
      setCard(prevCard => ({
        ...prevCard,
        expiryMonth: {
          ...prevCard.expiryMonth,
          error: prevCard.expiryMonth.required ? validateCard("expiryMonth", prevCard.expiryMonth.value, card) : ""
        },
        expiryMonth: {
          ...prevCard.expiryMonth,
          error: prevCard.expiryMonth.required ? validateCard("expiryMonth", prevCard.expiryMonth.value, card) : ""
        }
      }))
    }
    setCard(prevCard => ({
      ...prevCard,
      [ev.target.name]: {
        ...prevCard[ev.target.name],
        focused: true,
        error: prevCard[ev.target.name].required ? validateCard(ev.target.name, ev.target.value, card) : ""
      }
    }))
  }

  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  useEffect(() => {
    setStates(paymentInfo.states)
  }, [paymentInfo.states])

  useEffect(() => {
    setCities(paymentInfo.cities)
  }, [paymentInfo.cities])

  useEffect(() => {
    if (!paymentInfo.countriesRequested) {
      dispatch(getCountries())
    }
  }, [paymentInfo.countriesRequested])

  useEffect(() => {
    if (user && user.cfCountry && user.cfCountry.value !== "") {
      dispatch(getStates({ isoCode: user.cfCountry.value, countryId: "" }))
    }
  }, [user.cfCountry.value])

  useEffect(() => {
    if (user.cfCountry.value !== "" && user.cfState.value !== "") {
      dispatch(getCities({ countryId: "", stateId: "", countryCode: user.cfCountry.value, isoCode: user.cfState.value }))
    }
  }, [user.cfState.value])

  useEffect(()=>{
    if (paymentInfo.loadedFirstTime){
      dispatch(resetSignUp())
    }
  }, [paymentInfo.loadedFirstTime])

  useEffect(() => {
    if (paymentInfo.subscriptionPlan.length === 0) {
      window.location.href = "https://www.marquet.cloud/pricing";
    }
  }, [paymentInfo.subscriptionPlan])

  useEffect(() => {
    if (!paymentInfo.userRequested) {
      dispatch(getCustomerId());
    }
  }, [paymentInfo.userRequested])

  useEffect(() => {
    if (paymentInfo.userHasCard){
      setUseNewCard(false);
    }
  }, [paymentInfo.userHasCard])

  useEffect(() => {
    if (useCustomerData){
      let currentKeys = Object.keys(user)
      currentKeys.map((key) => {
        if (paymentInfo && paymentInfo.user && paymentInfo.user.hasOwnProperty([key])){
          setUser(prevUser => ({
            ...prevUser,
            [key] : {
              ...prevUser[key],
              value: paymentInfo.user[key],
              focused: true,
              error: prevUser[key].required ? validateBilling(key, paymentInfo.user[key]) : ""
            }
          }))
        }
      })
    } else if (!useCustomerData){
      let currentKeys = Object.keys(user)
      currentKeys.map(key => {
        if (paymentInfo.user.hasOwnProperty([key])) {
          setUser(prevUser => ({
            ...prevUser,
            [key]: {
              ...prevUser[key],
              value: "",
              focused: true,
              error: prevUser[key].required ? validateBilling(key, "") : ""
            }
          }))
        }
      })
    }
  }, [useCustomerData, paymentInfo.user])

  useEffect(() => {
    if (!useNewCard) {
      let currentKeys = Object.keys(card)
      currentKeys.map(key => {
        if (paymentInfo.card.hasOwnProperty([key])) {
          setCard(prevCard => ({
            ...prevCard,
            [key]: {
              ...prevCard[key],
              value: paymentInfo.card[key],
              focused: true,
              error: ""
            }
          }))
        }else if(key === "cvc"){
          setCard(prevCard => ({
            ...prevCard,
            [key]: {
              ...prevCard[key],
              value: "",
              focused: false,
              error: ""
            }
          }))
        }
      })
    } else if (useNewCard && paymentInfo.userHasCard){
      if (Object.keys(paymentInfo.card).length > 0) {
        let currentKeys = Object.keys(card)
        currentKeys.map((key) => {
          if (paymentInfo.card.hasOwnProperty([key])) {
            setCard(prevCard => ({
              ...prevCard,
              [key]: {
                ...prevCard[key],
                value: "",
                focused: true,
                error: prevCard[key].required ? validateCard(key, "", card) : ""
              }
            }))
          } else if (key === "cvc") {
            setCard(prevCard => ({
              ...prevCard,
              [key]: {
                ...prevCard[key],
                value: "",
                focused: true,
                error: prevCard[key].required ? validateCard(key, "", card) : ""
              }
            }))
          }
        })
      }
    }
  }, [useNewCard, paymentInfo.card])

  useEffect(() => {
    let subTotal = 0;
    let tax = 0
    let total = 0
    if (paymentInfo && paymentInfo.subscriptionPlan && paymentInfo.subscriptionPlan.length > 0) {
      paymentInfo.subscriptionPlan.map((item) => {
        subTotal += (item.quantity * item.unitPrice)
        total += (item.quantity * item.unitPrice)
      })
      if (user.cfCountry.value === "CA") {
        tax = (subTotal * 0.13)
        total += (subTotal * 0.13)
      }
      setTotals({
        subTotal: (subTotal/100).toLocaleString('en-US', { style: 'currency', currency: paymentInfo.subscriptionPlan[0].itemPriceId.split("-")[1] }),
        tax: (tax/100).toLocaleString('en-US', { style: 'currency', currency: paymentInfo.subscriptionPlan[0].itemPriceId.split("-")[1] }),
        total: (total/100).toLocaleString('en-US', { style: 'currency', currency: paymentInfo.subscriptionPlan[0].itemPriceId.split("-")[1] })
      })
    }
  },[paymentInfo, user.cfCountry.value])

  useEffect(() => {
    if (paymentInfo.redirect && paymentInfo.target !== ""){
      navigate(paymentInfo.target)
    }
  }, [paymentInfo.redirect])

  useEffect(() => {
    if (paymentInfo.updatedBillingData && paymentInfo.createSubscription){
      let subscription = camelToSnake(paymentInfo.subscriptionPlan)
      dispatch(createCustomerSubscription({ customerId: paymentInfo.user.id, subscription: subscription }))
    }
  }, [paymentInfo.createSubscription && paymentInfo.updatedBillingData])

  function disabledSubmit() {
    if (paymentInfo.loading){
      return true
    }
    let userKeys = Object.keys(user)
    let cardKeys = Object.keys(card)
    for (let i = 0; i < userKeys.length; i++) {
      if (user[userKeys[i]].required) {
        if (user[userKeys[i]].focused && user[userKeys[i]].error !== "") {
          return true
        } else if (!user[userKeys[i]].focused) {
          return true
        }
      }
    }
    if(!terms.term2 || !terms.term3){
      return true
    }
    return false
  }

  const updateBillingData = () => {
    let billingInfo = {
      first_name: user.firstName.value,
      last_name: user.lastName.value,
      company: paymentInfo.user.company,
      country: user.cfCountry.value,
      state: user.cfState.value,
      email: user.email.value,
      phone: `${user.cfDialCountryCode.value}${user.cfSinglePhoneNumber.value}`,
      city: user.cfCity.value,
      line1: user.cfAddress.value,
      zip: user.cfZip.value
    }
    if (billingInfo.zip === "") {
      delete billingInfo["zip"]
    }
    dispatch(updateBillingInfo({ customerId: paymentInfo.user.id, billingInfo }))
  }

  const paymentMethodSave = () => {
    if (useNewCard && paymentInfo.userHasCard) {
      let dataCard = {
        replace_primary_payment_source: true,
        card: {
          first_name: card.firstName.value,
          last_name: card.lastName.value,
          number: card.maskedNumber.value,
          cvv: card.cvc.value,
          expiry_month: parseInt(card.expiryMonth.value),
          expiry_year: parseInt(card.expiryYear.value)
        }
      }
      dispatch(updateCustomerCard(dataCard));
    } else if (!paymentInfo.userHasCard) {
      let dataCard = {
        replace_primary_payment_source: true,
        card: {
          first_name: card.firstName.value,
          last_name: card.lastName.value,
          number: card.maskedNumber.value,
          cvv: card.cvc.value,
          expiry_month: parseInt(card.expiryMonth.value),
          expiry_year: parseInt(card.expiryYear.value)
        }
      }
      dispatch(createCustomerCard({ customerId: paymentInfo.user.id, dataCard }))
    }
  }

  const saveData = (ev) => {
    ev.preventDefault();
    paymentMethodSave();
    if (!useNewCard && paymentInfo.userHasCard){
      updateBillingData();
    }
  }

  useEffect(() => {
    if (paymentInfo.updateBillingData){
      updateBillingData();
    }
  }, [paymentInfo.updateBillingData])

  useEffect(()=>{
    if (paymentInfo.subscriptionCreated){
      let planData = {
        hubspotDealId: paymentInfo.user.cfHubspotDealId,
        dealStage: "processed",
        frequency: paymentInfo.subscriptionPlan[0].itemPriceId.split("-")[2],
        amount: paymentInfo.invoice.amountPaid / 100,
        code: paymentInfo.subscriptionPlan[0].itemPriceId,
        currency: paymentInfo.subscriptionPlan[0].itemPriceId.split("-")[1],
        subscriptionInformation: {
          subscriptionId: paymentInfo.subscription.id,
          subscriptionStatus: paymentInfo.subscription.status,
          subscriptionMRR: paymentInfo.subscription.mrr,
          product: paymentInfo.subscription.subscriptionItems[0].itemPriceId,
          planQuantity: paymentInfo.subscription.subscriptionItems[0].quantity,
          nextBillingAt: paymentInfo.subscription.nextBillingAt,
          nextBillingAmount: paymentInfo.subscription.subscriptionItems[0].amount
        }
      }
      if (paymentInfo.isNewUser) {
        dispatch(updateDeal({ planData: planData}));
      } else {
        delete planData['hubspotDealId'];
        let deal = {
          customerData: {
            hubspotContactId: paymentInfo.user.cfHubspotContactId,
            company: paymentInfo.user.company
          },
          planData: planData
        }
        dispatch(createDeal(deal));
      }
    }
  }, [paymentInfo.subscriptionCreated])

  useEffect(() =>{
    if (paymentInfo.dealUpdated){
      let contactInfo = {
        customerData: {
          hubspotContactId: paymentInfo.user.cfHubspotContactId,
          billingInformation: {
            billingAddress: user.cfAddress.value,
            billingCity: user.cfCity.value,
            billingZip: user.cfZip.value,
            billingStateCode: user.cfState.value,
            billingCountryCode: user.cfCountry.value,
            emailBilling: user.email.value,
            phone: `${user.cfDialCountryCode.value}${user.cfSinglePhoneNumber.value}`,
            firstNameBilling: user.firstName.value,
            LastNameBilling: user.lastName.value,
            preferredCurrencyCode: paymentInfo.user.preferredCurrencyCode,
          },
          siteName: "marquet",
          subscriptionId: paymentInfo.subscription.id,
          subscriptionStatus: paymentInfo.subscription.status,
          subscriptionMRR: paymentInfo.subscription.mmr,
          product: paymentInfo.subscription.subscriptionItems[0].itemPriceId,
          planQuantity: paymentInfo.subscription.subscriptionItems[0].quantity,
          nextBillingAt: paymentInfo.subscription.nextBillingAt,
          nextBillingAmount: paymentInfo.subscription.subscriptionItems[0].amount,
          acceptsMarketing: terms.term1,
          acceptsPersonalData: terms.term2,
          acceptsTermsConditions: terms.term3
        }
      }
      dispatch(updateContact(contactInfo));
    }
  }, [paymentInfo.dealUpdated])

  if (!paymentInfo.loadedFirstTime){
    return (
      <PaymentSkeleton/>
    )
  }

  return (
    <>
      <div className='payment--methods'>
        <form className='payment--container marquet--form two--columns--form' onSubmit={(ev) => { saveData(ev) }}>
          <div className='marquet--form--titles'>
            <h3>BILLING INFORMATION</h3>
            <div className="check--info">
              <input type="checkbox"
                checked={useCustomerData}
                name="customerData"
                onChange={ev => { setUseCustomerData(!useCustomerData) }}
              />
              <label>Same as my account information</label>
            </div>
          </div>
          <div className="marquet--form--group">
            <div className={inputStatus(user, "firstName")}>
              <label>
                FIRST NAME<b> *</b>
              </label>
              <input
                name="firstName"
                type="text"
                maxLength={30}
                onChange={ev => handleInputChangeUser(ev)}
                onFocus={ev => handleOnFocusBilling(ev)}
                value={user.firstName.value} />
            </div>
            <div className="invalid--feedback">{user.firstName.error}</div>
          </div>
          <div className="marquet--form--group">
            <div className={inputStatus(user, "lastName")}>
              <label>
                LAST NAME<b> *</b>
              </label>
              <input
                name="lastName"
                type="text"
                maxLength={30}
                onChange={ev => handleInputChangeUser(ev)}
                onFocus={ev => handleOnFocusBilling(ev)}
                value={user.lastName.value} />
            </div>
            <div className="invalid--feedback">{user.lastName.error}</div>
          </div>
          <div className="marquet--form--group">
            <div className={inputStatus(user, "cfCountry")}>
              <label>
                COUNTRY<b> *</b>
              </label>
              <select
                name="cfCountry"
                type="select"
                onChange={ev => handleInputChangeUser(ev)}
                onFocus={ev => handleOnFocusBilling(ev)}
                value={user.cfCountry.value}>
                <option value="">Select one</option>
                {paymentInfo && paymentInfo.countries && paymentInfo.countries.length > 0 && paymentInfo.countries.map((country, index) => {
                  return (
                    <option key={index} value={country.isoCode}>
                      {country.name}
                    </option>
                  )
                })}
              </select>
            </div>
            <div className="invalid--feedback">{user.cfCountry.error}</div>
          </div>
          <div className="marquet--form--group">
            <div className={inputStatus(user, "cfState")}>
              <label>
                STATE / PROVINCE<b> *</b>
              </label>
              {paymentInfo.statesRequested ?
                <div className="input--loading">
                  <Loader size="xs" />
                </div>
                :
                <select
                  name="cfState"
                  type="select"
                  onChange={ev => handleInputChangeUser(ev)}
                  onFocus={ev => handleOnFocusBilling(ev)}
                  value={user.cfState.value}
                  style={paymentInfo.statesRequested ? { cursor: "progress !important" } : { cursor: "default" }}
                  disabled={paymentInfo.statesRequested}>
                  <option value="">Select one</option>
                  {states && states.length > 0 && states.map((state, index) => (
                    <option key={index} value={state.isoCode}>
                      {state.name}
                    </option>
                  ))
                  }
                </select>
              }
            </div>
            <div className="invalid--feedback">{user.cfState.error}</div>
          </div>
          <div className="marquet--form--group">
            <div className='input--group'>
              <label>
                CITY{/*<b> *</b>*/}
              </label>
              {paymentInfo.citiesRequested || paymentInfo.statesRequested ?
                <div className="input--loading">
                  <Loader size="xs" />
                </div>
                :
                <select
                  name="cfCity"
                  type="select"
                  onChange={ev => handleInputChangeUser(ev)}
                  onFocus={ev => handleOnFocusBilling(ev)}
                  value={user.cfCity.value}
                  style={paymentInfo.citiesRequested || paymentInfo.statesRequested ? { cursor: "progress !important" } : { cursor: "default" }}
                  disabled={paymentInfo.citiesRequested || paymentInfo.statesRequested}>
                  <option value="">Select one</option>
                  {cities && cities.length > 0 && cities.map((city, index) => {
                    return (
                      <option key={index} value={city.name}>
                        {city.name}
                      </option>
                    )
                  })
                  }
                </select>
              }
            </div>
            <div className="invalid--feedback">{user.cfCity.error}</div>
          </div>
          <div className="marquet--form--group">
            <div className={inputStatus(user, "cfAddress")}>
              <label>
                ADDRESS<b> *</b>
              </label>
              <input
                name="cfAddress"
                type="text"
                maxLength={50}
                onChange={ev => handleInputChangeUser(ev)}
                onFocus={ev => handleOnFocusBilling(ev)}
                value={user.cfAddress.value} />
            </div>
            <div className="invalid--feedback">{user.cfAddress.error}</div>
          </div>
          <div className="marquet--form--group">
            <div className={
              user.cfDialCountryCode.focused || user.cfSinglePhoneNumber.focused ?
                user.cfDialCountryCode.error === "" && user.cfSinglePhoneNumber.error === "" ?
                  "input--group input--success" : "input--group input--error"
                : "input--group"
            }>
              <label>
                PHONE<b> *</b>
              </label>
              <div className="row--form">
                <select
                  name="cfDialCountryCode"
                  type="select"
                  onChange={ev => handleInputChangeUser(ev)}
                  onFocus={ev => handleOnFocusBilling(ev)}
                  value={user.cfDialCountryCode.value}>
                  <option value="">Select one</option>
                  {dialCodes && dialCodes.length > 0 && dialCodes.map((country, index) => {
                    return (
                      <option key={index} value={country.dialCode}>
                        {`${country.name} (${country.dialCode})`}
                      </option>
                    )
                  })}
                </select>
                <div className="separation"></div>
                <input
                  name="cfSinglePhoneNumber"
                  type="text"
                  maxLength={15}
                  onChange={ev => handleInputChangeUser(ev)}
                  onFocus={ev => handleOnFocusBilling(ev)}
                  value={user.cfSinglePhoneNumber.value} />
              </div>
            </div>
            <div className="invalid--feedback">{`${user.cfDialCountryCode.error} ${user.cfSinglePhoneNumber.error}`}</div>
          </div>
          <div className="marquet--form--group">
            <div className={user.email.focused === true ?
              user.email.error === "" ? "input--group input--success" : "input--group input--error" : "input--group"}>
              <label>
                EMAIL<b> *</b>
              </label>
              <input
                name="email"
                type="email"
                maxLength={50}
                onChange={ev => handleInputChangeUser(ev)}
                onFocus={ev => handleOnFocusBilling(ev)}
                value={user.email.value} />
            </div>
            <div className="invalid--feedback">{user.email.error}</div>
          </div>
          <div className="marquet--form--group">
            <div className='input--group'>
              <label>ZIP / POSTAL CODE</label>
              <input
                name="cfZip"
                type="text"
                maxLength={15}
                onChange={ev => handleInputChangeUser(ev)}
                value={user.cfZip.value} />
            </div>
          </div>
          <div className='marquet--form--titles'>
            <h3>CREDIT CARD INFORMATION</h3>
            {paymentInfo.userHasCard &&
              <div className="check--info">
                <input type="checkbox"
                  checked={useNewCard}
                  name="useNewCard"
                  onChange={ev => { setUseNewCard(!useNewCard); }} />
                <label>Use a different card</label>
              </div>
            }
          </div>
          <div className="marquet--form--group">
            <div className={inputStatus(card, "firstName")}>
              <label>
                FIRST NAME<b> *</b>
              </label>
              <input
                name="firstName"
                type="text"
                maxLength={30}
                disabled={paymentInfo.userHasCard && !useNewCard ? true : false}
                onChange={ev => handleInputChangeCard(ev)}
                onFocus={ev => handleOnFocusCard(ev)}
                value={card.firstName.value} />
            </div>
            <div className="invalid--feedback">{card.firstName.error}</div>
          </div>
          <div className="marquet--form--group">
            <div className={inputStatus(card, "lastName")}>
              <label>
                LAST NAME<b> *</b>
              </label>
              <input
                name="lastName"
                type="text"
                maxLength={30}
                disabled={paymentInfo.userHasCard && !useNewCard ? true : false}
                onChange={ev => handleInputChangeCard(ev)}
                onFocus={ev => handleOnFocusCard(ev)}
                value={card.lastName.value} />
            </div>
            <div className="invalid--feedback">{card.lastName.error}</div>
          </div>
          <div className="marquet--form--group">
            <div className={inputStatus(card, "maskedNumber")}>
              <label>
                CREDIT CARD NUMBER<b> *</b>
              </label>
              <input
                name="maskedNumber"
                type="text"
                maxLength={16}
                disabled={paymentInfo.userHasCard && !useNewCard ? true : false}
                onChange={ev => handleInputChangeCard(ev)}
                onFocus={ev => handleOnFocusCard(ev)}
                value={card.maskedNumber.value} />
            </div>
            <div className="invalid--feedback">{card.maskedNumber.error}</div>
          </div>
          <div className="marquet--form--group">
            <div className={
              card.expiryMonth.focused || card.expiryYear.focused ?
                card.expiryMonth.error === "" && card.expiryYear.error === "" ?
                  "input--group input--success" : "input--group input--error"
                : "input--group"
              }>
              <label>
                EXPIRY DATE<b> *</b>
              </label>
              <div className="row--form">
                <select
                  name="expiryYear"
                  type="text"
                  style={{ width: "50%" }}
                  disabled={paymentInfo.userHasCard && !useNewCard ? true : false}
                  onChange={ev => handleInputChangeCard(ev)}
                  onFocus={ev => handleOnFocusCard(ev)}
                  value={card.expiryYear.value} >
                  <option value="">YY</option>
                  {renderCardYear()}
                </select>
                <select
                  name="expiryMonth"
                  type="text"
                  style={{ width: "50%" }}
                  disabled={paymentInfo.userHasCard && !useNewCard ? true : false}
                  onChange={ev => handleInputChangeCard(ev)}
                  onFocus={ev => handleOnFocusCard(ev)}
                  value={card.expiryMonth.value} >
                  <option value="">MM</option>
                  {renderCardMonth()}
                </select>
              </div>
            </div>
            <div className="invalid--feedback">{`${card.expiryMonth.error} ${card.expiryYear.error}`}</div>
          </div>
          {!(paymentInfo.userHasCard && !useNewCard) &&
            <div className="marquet--form--group">
              <div className={inputStatus(card, "cvc")}>
                <label>
                  CVC<b> *</b>
                </label>
                <input
                  name="cvc"
                  type="password"
                  maxLength={3}
                  onChange={ev => handleInputChangeCard(ev)}
                  onFocus={ev => handleOnFocusCard(ev)}
                  value={card.cvc.value} />
              </div>
              <div className="invalid--feedback">{card.cvc.error}</div>
            </div>
          }
          <div className="privacy--policy row">
            <p>
              Marquet is committed to protecting and respecting your
              privacy, and we’ll only use your personal information to
              administer your account and to provide the products and services
              you requested from us. From time to time, we would like to
              contact you about our products and services, as well as other
              content that may be of interest to you. If you consent to us
              contacting you for this purpose, please tick below to say how
              you would like us to contact you:
            </p>
            <div className="form--checks">
              <input name="term1" type="checkbox" onChange={ev=>handleTerms(ev)} value={terms.term1} />
              <p>I agree to receive other communications from Marquet.</p>
            </div>
            <p>
              You can unsubscribe from these communications at any time.
              For more information on how to unsubscribe, our privacy
              practices, and how we are committed to protecting and
              respecting your privacy, please review our <a href="https://www.marquet.cloud/privacy-policy.html" target={"_blank"} rel="noreferrer" className="custom--links">privacy policy</a>.
            </p>
            <div className="form--checks">
              <input name="term2" type="checkbox" onChange={ev => handleTerms(ev)} value={terms.term1} />
              <p>
                I agree to allow Marquet to store and process my personal data.<b style={{ color: "#801139" }}>*</b>
              </p>
            </div>
            <p>
              In order to provide you the content requested, we need to store
              and process your personal data. If you consent to us storing your
              personal data for this purpose, please tick the checkbox below.
            </p>
            <div className="form--checks">
              <input name="term3" type="checkbox" onChange={ev => handleTerms(ev)} value={terms.term1} />
              <p>
                I agree to the
                <a href="https://www.marquet.cloud/terms-and-conditions"
                  target={"_blank"}
                  rel="noreferrer"
                  className="custom--links"> terms and conditions </a>
                and the
                <a href="https://www.marquet.cloud/automatic-renewal-terms.html"
                  target={"_blank"}
                  rel="noreferrer"
                  className="custom--links"> automatic renewal terms</a>
                <b style={{ color: "#801139" }}>*</b>
              </p>
            </div>
          </div>
          <div className="marquet--button--group button-end">
            <button
              className="custom--button custom--button--marquet"
              disabled={disabledSubmit()}
              type='submit'>
              Subscribe
              {paymentInfo.loading && <Loader size="xs" />}
            </button>
          </div>
        </form>
        <div className="subscription">
          {paymentInfo.subscriptionPlan && paymentInfo.subscriptionPlan.length > 0 &&
            <MarquetCards classStyles={"subscription--card"}>
              <div className="top--card--title">
                <span>Subscribe To</span>
              </div>
              <div>
                <h3>
                  {paymentInfo.subscriptionPlan[0].name}
                </h3>
              </div>
              <div className="item--price">
                <div>
                  <h4>Subscription Fee</h4>
                  <i></i>
                  <span>
                    {`${(paymentInfo.subscriptionPlan[0].unitPrice/100).toLocaleString('en-US', { style: 'currency', currency: paymentInfo.subscriptionPlan[0].itemPriceId.split("-")[1] })}`}
                  </span>
                </div>
                <div className="subscription--frecuency">{`Billed ${paymentInfo.subscriptionPlan[0].itemPriceId.split("-")[2]}`}</div>
              </div>
              <div className="subscription--details">
                <div>
                  <h4>Add-ons</h4>
                </div>
                {paymentInfo.subscriptionPlan.map((it, i) => {
                  if (i > 0) {
                    return (
                      <div key={i} className="item--price">
                        <div>
                          <h5>{`${it.quantity} ${it.name}`}</h5>
                          <i></i>
                          <span>{`${((paymentInfo.subscriptionPlan[0].unitPrice * paymentInfo.subscriptionPlan[0].quantity)/100).toLocaleString('en-US', { style: 'currency', currency: paymentInfo.subscriptionPlan[0].itemPriceId.split("-")[1] })}`}</span>
                        </div>
                        <div className="subscription--frecuency">Billed Annually</div>
                      </div>
                    )
                  }
                })}
                <div className="item--price">
                  <div>
                    <h4>SUB-TOTAL</h4>
                    <i></i>
                    <span>{totals.subTotal}</span>
                  </div>
                </div>
                <div className="item--price">
                  <div>
                    <h4>TAX</h4>
                    <i></i>
                    <span>{totals.tax}</span>
                  </div>
                </div>
                <div className="item--price">
                  <div>
                    <h4>TOTAL</h4>
                    <i></i>
                    <span>{totals.total}</span>
                  </div>
                </div>
              </div>
            </MarquetCards>
          }
        </div>
      </div>
    </>
  )
}

export default Payment;